import { render } from "./ReceiveCheckInfo.vue?vue&type=template&id=479f6846&scoped=true"
import script from "./ReceiveCheckInfo.vue?vue&type=script&lang=js"
export * from "./ReceiveCheckInfo.vue?vue&type=script&lang=js"

import "./ReceiveCheckInfo.vue?vue&type=style&index=0&id=479f6846&scoped=true&lang=css"

import exportComponent from "D:\\projects\\wmsapp\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-479f6846"]])

export default __exports__